var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"prepend-icon":"mdi mdi-translate","filled":"","hide-details":"","outlined":"","items":_vm.items},on:{"change":_vm.change},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})}
var staticRenderFns = []

export { render, staticRenderFns }